import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { FaRupeeSign } from "react-icons/fa";
import { FiArrowRight, FiCalendar, FiXCircle, FiEye } from "react-icons/fi";
import { GoBriefcase } from "react-icons/go";
import { IoCalendarOutline } from "react-icons/io5";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { withRouter } from "react-router";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import MyYuukke from "../../../api/MyYuukke";
import ProfileService from "../../../api/ProfileService";
import { SOCKET_URL } from "../../../chatPanel/src/config/config.js";
import RazorPay from "../../../components/RazorPay2.jsx";
import { API_URL, REACT_APP_SITE_KEY } from "../../../config/app-config";
import faceBook from "../../../images/SocialMediaGif/Facebook.png";
import instagram from "../../../images/SocialMediaGif/instagram.png";
import personalWebsite from "../../../images/SocialMediaGif/internet.png";
import linkedIn from "../../../images/SocialMediaGif/Linkedin.png";
import youtube from "../../../images/SocialMediaGif/youtube.png";
import { IoClose } from "react-icons/io5";
import BlockUi from "react-block-ui";
import { useDispatch, useSelector } from "react-redux";
import { getUserSlots } from "../../../redux/actions/calendarAction";
import Select from "react-select";
import CheckBox from "../../../components/CheckBox";
import ImagePreview from "../../../components/ImagePreview";
import StepperFileOption from "../../Wizard/StepperFileOption";
import { urlPatternValidation } from "../../../utils";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import TextEditorQuestion from "../../../components/TextEditorQuestion";
import { fontOptions, timeZone } from "../../../sampleData/Options";
import ChooseFileComponent from "../../../components/ChooseFileComponent";
import ColorPickerV2 from "../../../components/ColorPickerV2";
import { dBody, dropFlowStyle } from "../../../components/Utils";
import { IconButton, Modal } from "@material-ui/core";

import "./CalendarPlans-responsive.css";

// ─── Theme Imports ─────────────────────────────────────────────────────────
import DefaultThemeProfile from "../../FirstTimeProfile/CalendarVcardV2"; // Default (0)
import ServiceCardThemeV2 from "../../FirstTimeProfile/ServiceCardThemeV2";
import ServiceCardThemeV3 from "../../FirstTimeProfile/ServicecardthemeV3";
import ServiceCardThemeV4 from "../../FirstTimeProfile/ServiceCardThemeV4";
import ServiceCardThemeV5 from "../../FirstTimeProfile/ServiceCardThemeV5";
import ServiceCardThemeV6 from "../../FirstTimeProfile/ServiceCardThemeV6";
import ServiceCardThemeV7 from "../../FirstTimeProfile/ServiceCardThemeV7";
import ServiceCardThemeV8 from "../../FirstTimeProfile/ServiceCardThemeV8";
import ServiceCardThemeV9 from "../../FirstTimeProfile/ServiceCardThemeV9";
import ServiceCardThemeV10 from "../../FirstTimeProfile/ServiceCardThemeV10";
import ServiceCardThemeV11 from "../../FirstTimeProfile/ServiceCardThemeV11";
import ServiceCardThemeV12 from "../../FirstTimeProfile/ServiceCardThemeV12";
import ServiceCardThemeV13 from "../../FirstTimeProfile/ServiceCardThemeV13";
import ServiceCardThemeV14 from "../../FirstTimeProfile/ServiceCardThemeV14";
import ServiceCardThemeV15 from "../../FirstTimeProfile/ServiceCardThemeV15";
import ServiceCardThemeV16 from "../../FirstTimeProfile/ServiceCardThemeV16";
import ServiceCardThemeV17 from "../../FirstTimeProfile/ServiceCardThemeV17";
import ServiceCardThemeV18 from "../../FirstTimeProfile/ServiceCardThemeV18";

// ─── Performant Theme Registry ──────────────────────────────────────────────
// Mirrors CalendarVcard's THEME_COMPONENTS exactly — DefaultThemeProfile is
// NOT in this map; it's the explicit fallback when themeCard isn't a key here.
const THEME_COMPONENTS = {
  1: ServiceCardThemeV2,
  3: ServiceCardThemeV3,
  4: ServiceCardThemeV4,
  5: ServiceCardThemeV5,
  6: ServiceCardThemeV6,
  7: ServiceCardThemeV7,
  8: ServiceCardThemeV8,
  9: ServiceCardThemeV9,
  10: ServiceCardThemeV10,
  11: ServiceCardThemeV11,
  12: ServiceCardThemeV12,
  13: ServiceCardThemeV13,
  14: ServiceCardThemeV14,
  15: ServiceCardThemeV15,
  16: ServiceCardThemeV16,
  17: ServiceCardThemeV17,
  18: ServiceCardThemeV18,
};

// Theme 1 (ServiceCardThemeV2) doesn't accept an isPreview prop — matches
// CalendarVcard's THEME_CARD_WITHOUT_PREVIEW_PROP.
const THEME_CARD_WITHOUT_PREVIEW_PROP = new Set([1]);

// NOTE: `themeId` is the id of the colour preset the user picked in
// ColorPickerV2 — it is INDEPENDENT of the page layout theme (`uiTheme`).
// A profile can be Minimal layout + a custom colour preset, or any other
// layout + no custom colours. Do not derive one from the other.

// ─── AI Theme Suggestion Engine ──────────────────────────────────────────────
const getThemeSuggestions = (categories) => {
  if (!categories || categories.length === 0) return [1];
  const primaryCat = categories[0];
  const catId = primaryCat?.categoryId || primaryCat?.primaryId;

  const suggestions = {
    1: [11, 4, 5],       // Lifestyle -> Creative Atelier (11), Sanctuary (4), Sunrise (5)
    2: [17, 18, 12],     // Financial/Legal -> Strategy Brief (17), Systems (18), Map-room (12)
    3: [18, 17, 12, 15], // Consulting -> Systems (18), Strategy (17), Map-room (12), Dossier (15)
    4: [10, 13, 15, 14], // Education -> Conversations (10), Study Desk (13), Dossier (15), Language (14)
    5: [11, 16, 17],     // Marketing -> Creative Atelier (11), Operator (16), Strategy Brief (17)
    6: [9, 10, 4]        // Well-being -> Movement Lab (9), Conversations (10), Sanctuary (4)
  };

  return suggestions[catId] || [1];
};

/* ─────────────────────────────────────────────────────────────────────────────
   SUB-COMPONENTS
───────────────────────────────────────────────────────────────────────────── */
const PanelHeader = ({ num, icon, title, subtitle, done }) => (
  <div className="cps-panel-head">
    <div className="cps-panel-left">
      <div className={`cps-panel-badge ${done ? "done" : "pending"}`}>
        {done ? "✓" : num}
      </div>
      <div>
        <div className="cps-panel-title">
          {icon}&nbsp;{title}
        </div>
        <div className="cps-panel-sub">{subtitle}</div>
      </div>
    </div>
    {done && <span className="cps-done-pill">Complete</span>}
  </div>
);

const Field = ({ label, hint, required, why, children, className = "" }) => (
  <div className={`cps-field ${className}`}>
    <label className="cps-label">
      {label}
      {required && <span className="cps-req"> *</span>}
    </label>
    {hint && <span className="cps-hint">{hint}</span>}
    {children}
    {why && <span className="cps-why">💡 {why}</span>}
  </div>
);

const ToggleCard = ({ label, hint, checked, onChange }) => (
  <div
    className={`cps-toggle-card ${checked ? "on" : ""}`}
    onClick={() => onChange(!checked)}
  >
    <div className="cps-toggle-dot">
      <svg className="cps-toggle-check" width="12" height="12" viewBox="0 0 11 11">
        <path d="M2 5.5l2.5 2.5L9 3" stroke="white" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
    <div>
      <div className="cps-t-label">{label}</div>
      {hint && <div className="cps-t-hint">{hint}</div>}
    </div>
  </div>
);

const TagInput = ({ tags, draft, onDraftChange, onChange, placeholder, maxTags = 20 }) => {
  const addTag = () => {
    const value = draft.trim();
    if (!value) return;
    if (tags.includes(value)) {
      onDraftChange("");
      return;
    }
    if (tags.length >= maxTags) return;
    onChange([...tags, value]);
    onDraftChange("");
  };

  const removeTag = (index) => {
    onChange(tags.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag();
    } else if (e.key === "Backspace" && !draft && tags.length > 0) {
      removeTag(tags.length - 1);
    }
  };

  return (
    <div className="cps-tag-input-wrap">
      {tags.map((tag, i) => (
        <span key={`${tag}-${i}`} className="cps-tag-chip">
          {tag}
          <button type="button" onClick={() => removeTag(i)} aria-label={`Remove ${tag}`}>
            ×
          </button>
        </span>
      ))}
      <input
        className="cps-tag-input"
        type="text"
        value={draft}
        onChange={(e) => onDraftChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={addTag}
        placeholder={tags.length === 0 ? placeholder : "Add another..."}
      />
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────────────────────────────────────── */
function CalendarPlans({ t, onBack }) {
  /* ── State ── */
  const [state, setState] = useState({
    activeMenu: 0,
    type: null,
    meetingInYuukke: true,
    paymentNeed: false,
    meetingLink: "",
    bookingCount: true,
    profilePhoto: true,
    freeCalendar: true,
    meetingPrize: "",
    businessLogo: null,
    emailReminder: true,
    whatsappReminder: false,
    apiLogo: false,
    editBusinessLogo: null,
    loader: false,
    paymentPage: false,
    subscribeId: 0,
    prize: 0,
    paymentStatus: "",
    subscriptionId: null,
    serviceName: "",
    serviceImage: "",
    editServiceLogo: null,
    apiGalleryImages: [],
    removedId: [],
    selectedGalleryImage: [],
    serviceApiLogo: false,
    serviceType: [],
    packageName: "",
    successPercent: 35,
    menuState: 0,
    serviceList: [],
    otherServiceName: "",
    pinCode: "",
    removedServiceCategoryId: [],
    categoryIds: [],
    description: "",
    subCategory: [],
    subCategoryList: [],
    timeZone: [],
    language: "",
    editDescription: "",
    countryList: [],
    country: "",
    phoneNumberShow: true,
    emailShow: true,
    minBookingCount: 2,
    demoSlotNeed: true,
    selectedServiceVideo: [],
    apiServiceVideo: [],
    removedServiceVideoId: [],
    selectedAnnounceMent: [],
    apiAnnounceMentImages: [],
    removedAnnounceMentId: [],
    editAnnounceMentContent: "",
    announceMentContent: "",
    theme: "#a00030",
    needCustomTheme: false,
    fontFamily: { label: "Poppins", value: "'Poppins', sans-serif" },
    changeMade: false,
    primaryColor: "",
    secondaryColor: "",
    headingColor: "",
    subHeadingColor: "",
    uiTheme: { value: 0, label: "Minimal" },
    sliderTextOne: "",
    sliderTextTwo: "",
    bookings: "",
    clients: "",
    ratings: "",
    showPreview: false,
    previewData: {},
    themeId: null,
    isUpdated: false, // Core state flag for tracking initial API load
    specialisations: [],
    successMetrics: {
      revenueGenerated: "",
      qualifiedLeads: "",
      avgConversionLift: "",
      avgRoas: "",
      avgCacReduction: "",
      organicSessionsPerYear: "",
      followersGrown: "",
      avgEmailOpenRate: "",
    },
  });

  const [specialisationDraft, setSpecialisationDraft] = useState("");
  const [activeSection, setActiveSection] = useState(1);

  /* ── Refs ── */
  const serviceNameRef = useRef(null);
  const meetingLinkRef = useRef(null);
  const minBookingCountRef = useRef(null);
  const sliderTextOneRef = useRef(null);
  const sliderTextTwoRef = useRef(null);
  const clientsRef = useRef(null);
  const previewTheme = useRef(0);
  const previewDataRef = useRef({});
  const recaptcha = useRef(null);
  const optionsMenu = useRef(null); // DefaultThemeProfile expects this ref

  const [previewData, setPreviewData] = useState({});
  // Local UI state that DefaultThemeProfile expects as individual props
  // (mirrors CalendarVcard's own local state, unused outside the preview).
  const [previewIsHovered, setPreviewIsHovered] = useState(false);
  const [previewShowServiceDropdown, setPreviewShowServiceDropdown] = useState(false);
  const [previewScrollPosition, setPreviewScrollPosition] = useState(0);
  const [previewCurrentIndex, setPreviewCurrentIndex] = useState(0);
  const [previewCalYear, setPreviewCalYear] = useState(() => new Date().getFullYear());
  const [previewCalMonth, setPreviewCalMonth] = useState(() => new Date().getMonth());
  const [previewServiceError, setPreviewServiceError] = useState(false);
  const [isPreviewVisible, setPreviewVisible] = useState(false);
  const [bookingThreshold, setBookingThreshold] = useState("");

  const uiTheme = [
    { value: 0, label: "Minimal" },
    { value: 1, label: "Enhanced" },
    { value: 3, label: "Profession-Specific 1" },
    { value: 4, label: "Sanctuary" },
    { value: 5, label: "Sunrise practice" },
    { value: 6, label: "Studio ritual" },
    { value: 7, label: "Performance training" },
    { value: 8, label: "Urban training club" },
    { value: 9, label: "Recovery and strength lab" },
    { value: 10, label: "Fireside conversation" },
    { value: 11, label: "Creative atelier" },
    { value: 12, label: "Map-room session" },
    { value: 13, label: "Study desk" },
    { value: 14, label: "Language club" },
    { value: 15, label: "Tutor dossier" },
    { value: 16, label: "Operator’s desk" },
    { value: 17, label: "Executive strategy brief" },
    { value: 18, label: "Systems workshop" },
  ];

  const hasSingleServiceType = (state.serviceType?.length ?? 0) === 1;

  // All layout themes are selectable regardless of how many service
  // types are chosen.
  const availableUiThemeOptions = uiTheme;

  const successMetricFields = [
    { key: "revenueGenerated", label: "Revenue generated", placeholder: "e.g. $84M+" },
    { key: "qualifiedLeads", label: "Qualified leads", placeholder: "e.g. 312k" },
    { key: "avgConversionLift", label: "Avg. conversion lift", placeholder: "e.g. +284%" },
    { key: "avgRoas", label: "Avg. ROAS", placeholder: "e.g. 5.8x" },
    { key: "avgCacReduction", label: "Avg. CAC reduction", placeholder: "e.g. -62%" },
    { key: "organicSessionsPerYear", label: "Organic sessions / yr", placeholder: "e.g. 12.4M" },
    { key: "followersGrown", label: "Followers grown", placeholder: "e.g. +920k" },
    { key: "avgEmailOpenRate", label: "Avg. email open rate", placeholder: "e.g. 48%" },
  ];

  const ratList = [
    "1", "2", "3", "4.1", "4.2", "4.3", "4.4", "4.5", "4.6", "4.7", "4.8", "4.9", "5"
  ].map((v) => ({ label: v, value: v }));

  /* ── Redux ── */
  const dispatch = useDispatch();
  const countryList = useSelector((s) => s.commonApi.countryName);
  const { loginDetails } = useSelector((s) => s.loginDetailsApi);
  const { userServiceList } = useSelector((s) => s.event);
  const { categoryV2, subCategoryV2, userSlots } = useSelector((s) => s.event);
  const { languagelist } = useSelector((s) => s.commonApi);

  /* ── Completion ── */
  const completionChecks = {
    identity: !!(
      state.serviceName &&
      state.serviceType?.length &&
      state.subCategory?.length &&
      state.country
    ),
    about: !!state.description,
    visibility: true,
    look: !!state.sliderTextOne,
    media: !!(state.businessLogo || state.editBusinessLogo),
    bookings: !!state.minBookingCount,
  };

  const highlightsDone =
    state.specialisations.length > 0 ||
    Object.values(state.successMetrics).some((v) => String(v || "").trim() !== "");

  const navItems = [
    { id: 1, icon: "🏢", label: "You", sub: "Name & basics", done: completionChecks.identity },
    { id: 2, icon: "✍️", label: "About", sub: "What you offer", done: completionChecks.about },
    { id: 3, icon: "📣", label: "Visibility", sub: "What clients see", done: completionChecks.visibility },
    { id: 4, icon: "📅", label: "Booking", sub: "How clients meet you", done: completionChecks.bookings },
    { id: 5, icon: "🎨", label: "Page style", sub: "Look & language", done: completionChecks.look },
    { id: 6, icon: "📸", label: "Media", sub: "Logo, gallery, video", done: completionChecks.media },
    ...(hasSingleServiceType ? [{ id: 7, icon: "📊", label: "Highlights", sub: "Specialities & numbers", done: highlightsDone }] : []),
  ];

  // Derived from navItems (not from completionChecks directly) so the count
  // always matches what's actually shown in the sidebar/subtitle — including
  // the 7th "Highlights" item when it's present. completionChecks alone only
  // ever has 6 keys, so computing the total from it caused "6 of 7" to show
  // even when all 7 items (including Highlights) were actually complete.
  const completedSections = navItems.filter((item) => item.done).length;
  const totalSections = navItems.length;
  const completionPercent = Math.round((completedSections / totalSections) * 100);

  /* ── Effects ── */
  useEffect(() => {
    if (countryList.length > 0) {
      const list = countryList.map((item) => ({
        value: item.id,
        label: item.nicename,
        id: item.id,
      }));
      updateState("countryList", list);
      const country = list.find((item) => item.value === userSlots?.preference?.countryId);
      if (country) updateState("country", country);
    }
  }, [countryList]);

  useEffect(() => {
    if (userSlots?.preference) {
      const slotDetails = userSlots.preference;
      const timeZoneData = timeZone.reduce((result, item) => {
        for (let i = 0; i < item.options.length; i++) {
          if (slotDetails.timeZone === item.options[i].value)
            return { label: item.options[i].label, value: item.options[i].value };
        }
        return result;
      }, {});
      const lan = slotDetails.language?.map((item) => ({ label: item.name, value: item.id }));

      let serviceIds = [];
      const cat = slotDetails.categorys.map((item) => {
        serviceIds.push(item.serviceId);
        return { label: item.categoryName, value: item.categoryId, categoryId: item.serviceId };
      });

      const serviceData = serviceIds.length > 0 ? categoryV2.filter((item) => serviceIds.includes(item.value)) : [];
      // NOTE: slotDetails.uiTheme can legitimately be 0 (Minimal), and 0 is
      // falsy in JS — `slotDetails?.uiTheme && uiTheme.find(...)` was
      // short-circuiting to 0 itself instead of looking it up, so
      // selectedTheme ended up as the raw number 0 rather than the
      // { value: 0, label: "Minimal" } option object. That broke the
      // layout Select (shown as blank/placeholder) and made every
      // `state.uiTheme.value !== 0` check evaluate as true, incorrectly
      // showing the tagline/clients/rating fields for Minimal too.
      const selectedTheme =
        slotDetails?.uiTheme !== undefined && slotDetails?.uiTheme !== null
          ? uiTheme.find((item) => item.value === slotDetails.uiTheme)
          : undefined;

      previewTheme.current = selectedTheme ? selectedTheme.value : state.uiTheme.value;

      const apiSpecialisations = slotDetails.specialisations ? slotDetails.specialisations.split(",").map((s) => s.trim()).filter(Boolean) : [];

      let apiSuccessMetrics = {};
      try {
        if (slotDetails.successMetrics && typeof slotDetails.successMetrics === "string") {
          apiSuccessMetrics = JSON.parse(slotDetails.successMetrics);
          if (typeof apiSuccessMetrics === "string") {
            apiSuccessMetrics = JSON.parse(apiSuccessMetrics);
          }
        } else if (typeof slotDetails.successMetrics === "object") {
          apiSuccessMetrics = slotDetails.successMetrics;
        }
      } catch (e) {
        console.error("Failed to parse successMetrics:", e);
      }

      setState((prev) => ({
        ...prev,
        isUpdated: true,
        timeZone: timeZoneData ?? [],
        subCategory: cat ?? [],
        language: lan ?? [],
        serviceType: serviceData,
        meetingInYuukke: slotDetails.meetingInApplication === null ? true : slotDetails.meetingInApplication,
        meetingLink: slotDetails.meetingUrl ?? "",
        bookingCount: slotDetails.showBookingCount === null ? true : slotDetails.showBookingCount,
        profilePhoto: slotDetails.showProfileImage === null ? true : slotDetails.showProfileImage,
        editBusinessLogo: slotDetails.businessLogo,
        apiLogo: true,
        apiGalleryImages: slotDetails.serviceGalleryImages ?? [],
        serviceApiLogo: true,
        serviceName: slotDetails.serviceName,
        pinCode: slotDetails.pinCode,
        editDescription: slotDetails.description ?? "",
        description: slotDetails.description ?? "",
        phoneNumberShow: slotDetails.phoneNumberShow,
        emailShow: slotDetails.emailShow,
        minBookingCount: slotDetails.minBookingCount,
        demoSlotNeed: slotDetails.demoSlotNeed,
        apiServiceVideo: slotDetails.sereviceVideo,
        apiAnnounceMentImages: slotDetails.announcement,
        editAnnounceMentContent: slotDetails.announcementContent ?? "",
        theme: slotDetails.theme ?? "#a00030",
        needCustomTheme: slotDetails.needCustomTheme ?? false,
        announceMentContent: slotDetails.announcementContent ?? "",
        fontFamily: slotDetails?.fontFamily ? findFont(slotDetails.fontFamily) : state.fontFamily,
        primaryColor: slotDetails.primaryColor ?? "#a00030",
        secondaryColor: slotDetails.secondaryColor ?? "#B7B7B7",
        headingColor: slotDetails.headingColor ?? "#000000",
        subHeadingColor: slotDetails.subHeadingColor ?? "#EEEEEE",
        uiTheme: selectedTheme ?? state.uiTheme,
        // themeId is independent of the layout — just hydrate whatever
        // colour preset (if any) was saved.
        themeId: slotDetails.themeId ?? null,
        sliderTextTwo: slotDetails.sliderTextTwo ?? "",
        sliderTextOne: slotDetails.sliderTextOne ?? "",
        clients: slotDetails.noOfClients ?? "",
        ratings: slotDetails.ratings ? { label: slotDetails.ratings, value: slotDetails.ratings } : "",
        specialisations: apiSpecialisations,
        successMetrics: { ...prev.successMetrics, ...(apiSuccessMetrics || {}) },
      }));

      if (serviceNameRef.current) serviceNameRef.current.value = slotDetails.serviceName ?? "";
      if (meetingLinkRef.current) meetingLinkRef.current.value = slotDetails.meetingUrl ?? "";
      if (minBookingCountRef.current) minBookingCountRef.current.value = slotDetails.minBookingCount ?? 2;
      if (sliderTextOneRef.current) sliderTextOneRef.current.value = slotDetails.sliderTextOne ?? "";
      if (sliderTextTwoRef.current) sliderTextTwoRef.current.value = slotDetails.sliderTextTwo ?? "";
      if (clientsRef.current) clientsRef.current.value = slotDetails.noOfClients ?? "";
      setBookingThreshold(slotDetails.minBookingCount ?? "");
    }
  }, [userSlots]);

  /* ── Helpers ── */
  const updateState = (name, value) => setState((prev) => ({ ...prev, [name]: value }));
  const changeMade = (name, value) => setState((prev) => ({ ...prev, [name]: value, changeMade: true }));

  const findFont = (family) => {
    const font = fontOptions.find((item) => item.value === family);
    if (font) document.documentElement.style.setProperty("--test-font", font.value);
    return font ?? { label: "Poppins", value: "'Poppins', sans-serif" };
  };

  const getRefValues = () => ({
    serviceName: serviceNameRef.current?.value ?? state.serviceName,
    meetingLink: meetingLinkRef.current?.value ?? state.meetingLink,
    minBookingCount: minBookingCountRef.current?.value ?? state.minBookingCount,
    sliderTextOne: sliderTextOneRef.current?.value ?? state.sliderTextOne,
    sliderTextTwo: sliderTextTwoRef.current?.value ?? state.sliderTextTwo,
    clients: clientsRef.current?.value ?? state.clients,
  });

  // ── Helpers copied from CalendarVcard so the preview matches the real
  // rendered page exactly (theme components rely on these being present).
  const toCamelCase = (str) => {
    if (!str || typeof str !== "string") return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word, index) =>
        index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(" ");
  };

  const getSliderText = (data) => {
    let list = [];
    if (data?.sliderTextOne) list.push(data.sliderTextOne);
    if (data?.sliderTextTwo) list.push(data.sliderTextTwo);
    if (list.length === 0) list.push("Book your appointment now");
    return list;
  };

  const updatePreferenceDetails = (refValues, type) => {
    const formData = new FormData();
    formData.append("meetingInApplication", state.meetingInYuukke);
    formData.append("showBookingCount", state.bookingCount);
    formData.append("showProfileImage", state.profilePhoto);
    formData.append("emailShow", state.emailShow);
    formData.append("phoneNumberShow", state.phoneNumberShow);
    formData.append("minBookingCount", refValues.minBookingCount ?? 2);
    if (state.pinCode) formData.append("pinCode", state.pinCode);
    if (state.businessLogo) formData.append("businessLogov2", state.businessLogo);
    formData.append("serviceName", refValues.serviceName);
    formData.append("meetingUrl", refValues.meetingLink || "");
    if (state.selectedGalleryImage?.length > 0)
      state.selectedGalleryImage.forEach((f) => formData.append("serviceGalleryImage", f));
    if (state.removedId.length > 0) formData.append("removedGalleryImageId", state.removedId);
    if (state.country) {
      formData.append("countryId", state.country.id);
      formData.append("countryName", state.country.label);
    }
    formData.append("description", state.description);
    formData.append("timeZone", state.timeZone.value);
    formData.append("language", JSON.stringify({ data: state.language.map((i) => ({ language: i.label, id: i.value })) }));
    formData.append("categoryV2", JSON.stringify({ data: state.subCategory.map((i) => ({ primaryId: i.categoryId, categoryId: i.value })) }));
    state.selectedAnnounceMent.forEach((f) => formData.append("serviceAnnouncement", f));
    state.selectedServiceVideo.forEach((f) => formData.append("serviceVideo", f));
    if (state.removedServiceVideoId.length > 0) formData.append("removedServiceVideoId", state.removedServiceVideoId);
    if (state.removedAnnounceMentId.length > 0) formData.append("removedServiceAnnouncementImageId", state.removedAnnounceMentId);
    if (state.demoSlotNeed != null) formData.append("demoSession", state.demoSlotNeed);
    if (state.theme !== null) formData.append("theme", state.theme);
    if (state.primaryColor) formData.append("primaryColor", state.primaryColor);
    if (state.secondaryColor) formData.append("secondaryColor", state.secondaryColor);
    if (state.headingColor) formData.append("headingColor", state.headingColor);
    if (state.subHeadingColor) formData.append("subHeadingColor", state.subHeadingColor);
    if (state.needCustomTheme != null) formData.append("customTheme", state.needCustomTheme);
    if (state.announceMentContent != null) formData.append("announcementContent", state.announceMentContent);
    if (state.fontFamily != null) formData.append("fontFamily", state.fontFamily?.value);
    if (state.uiTheme !== null) formData.append("uiTheme", state.uiTheme?.value);
    if (refValues.sliderTextOne) formData.append("sliderTextOne", refValues.sliderTextOne);
    if (refValues.sliderTextTwo) formData.append("sliderTextTwo", refValues.sliderTextTwo);
    // themeId is only ever a real numeric id (set via changeColor()) or
    // null (no custom colour preset chosen). Never send an empty string —
    // Spring's Integer binder rejects "" with a 400, which is what was
    // breaking Save whenever themeId ended up null.
    if (state.themeId !== null && state.themeId !== undefined && state.themeId !== "") {
      formData.append("themeId", state.themeId);
    }
    formData.append("noOfClients", refValues.clients);
    formData.append("ratings", state.ratings?.value ?? null);

    if (hasSingleServiceType) {
      if (state.specialisations?.length > 0) formData.append("specialisations", state.specialisations.join(","));
      const hasAnyMetric = Object.values(state.successMetrics || {}).some((v) => v !== null && v !== undefined && String(v).trim() !== "");
      if (hasAnyMetric) formData.append("successMetrics", JSON.stringify(state.successMetrics));
    }

    MyYuukke.updatePreference(formData, { headers: { "content-type": "multipart/form-data" } })
      .then(() => {
        setState((p) => ({ ...p, loader: false, changeMade: false }));
        dispatch(getUserSlots());
        if (type !== "update") onBack("calendar", true);
      })
      .catch(() => {
        toast.error("Something went wrong !");
        setState((p) => ({ ...p, loader: false, changeMade: false }));
      });
  };

  const updatePreference = (e, type) => {
    e.preventDefault();
    const refValues = getRefValues();
    if (!urlPatternValidation(refValues.meetingLink) && !state.meetingInYuukke) {
      toast.warning("Enter valid meeting url");
    } else if (!state.freeCalendar && !state.meetingPrize) {
      toast.warning("Enter your slot prize");
    } else if (!refValues.serviceName) {
      toast.warning("Enter service name");
    } else if (!state.serviceType.length) {
      toast.warning("Select your service related serviceType");
    } else if (!state.description) {
      toast.warning("Add your service details");
    } else {
      setState((p) => ({ ...p, loader: true }));
      updatePreferenceDetails(refValues, type);
    }
  };

  const removeApiGalleryImage = (index, type) => {
    if (type === "apiImage") {
      const list = state.apiGalleryImages.splice(index, 1);
      updateState("removedId", state.removedId.concat(list));
    } else {
      state.selectedGalleryImage.splice(index, 1);
      setState((p) => ({ ...p }));
    }
  };

  const removeServiceVideo = (index, type) => {
    if (type === "apiVideo") {
      const list = state.apiServiceVideo.splice(index, 1);
      setState((p) => ({ ...p, removedServiceVideoId: state.removedServiceVideoId.concat(list) }));
    } else {
      state.selectedServiceVideo.splice(index, 1);
      setState((p) => ({ ...p }));
    }
  };

  const removeAnnounceMentImage = (index, type) => {
    if (type === "apiImage") {
      const list = state.apiAnnounceMentImages.splice(index, 1);
      updateState("removedAnnounceMentId", state.removedAnnounceMentId.concat(list));
    } else {
      state.selectedAnnounceMent.splice(index, 1);
      setState((p) => ({ ...p }));
    }
  };

// Pure helper — no side effects, just computes the subcategory options
const computeSubCategories = (data, subCategoryV2) => {
  if (!data?.length) return [];
  const ids = data.map((i) => i.value);
  return subCategoryV2.reduce((result, d) => {
    if (ids.includes(d.categoryId)) {
      result = [
        ...result,
        ...d.subCategoryList.map((item) => ({
          label: item.subCategoryName,
          value: item.subCategoryId,
          categoryId: d.categoryId,
        })),
      ];
    }
    return result;
  }, []);
};

const getSubcategory = (data) => {
  const findSubCategory = computeSubCategories(data, subCategoryV2);

  setState((prev) => ({
    ...prev,
    serviceType: data,
    subCategoryList: findSubCategory,
    changeMade: true,
  }));
};

// Populate "Area of expertise" immediately if serviceType is already selected
// (e.g. loaded from saved/edit data) — runs once subCategoryV2 & serviceType are ready
useEffect(() => {
  if (state.serviceType?.length && subCategoryV2?.length && !state.subCategoryList?.length) {
    const findSubCategory = computeSubCategories(state.serviceType, subCategoryV2);
    setState((prev) => ({
      ...prev,
      subCategoryList: findSubCategory,
    }));
  }
}, [state.serviceType, subCategoryV2]);

  const onUploadSuccess = async (file) => {
    if (file.length > 1) {
      toast.warning("Please select single image");
      return;
    }
    updateState("selectedServiceVideo", [...state.selectedServiceVideo, file[0]]);
  };

  const updateSpecialisations = (tags) => changeMade("specialisations", tags);
  const updateSuccessMetric = (key, value) => {
    setState((prev) => ({
      ...prev,
      successMetrics: { ...prev.successMetrics, [key]: value },
      changeMade: true,
    }));
  };

  const changeColor = (color) => {
    const newState = {
      ...state,
      themeId: color?.id ?? null,
      primaryColor: color.primary,
      secondaryColor: color.secondary,
      headingColor: color.heading,
      subHeadingColor: color.subHeading,
    };
    onPreviewClick(newState, false);
    setState(newState);
  };

  // Layout theme change — does NOT touch themeId. themeId only changes
  // via changeColor() (user picking a colour preset) or on load hydration.
  const onUiThemeChange = (option) => {
    previewTheme.current = option.value;
    setState((prev) => ({
      ...prev,
      uiTheme: option,
      changeMade: true,
    }));
  };

  const toggleNeedCustomTheme = () => {
    setState((prev) => ({
      ...prev,
      needCustomTheme: !prev.needCustomTheme,
      changeMade: true,
    }));
  };

  const onPreviewClick = (currentState, isShow) => {
    let ann = [], gal = [], vid = [];

    if (currentState.selectedAnnounceMent?.length > 0) {
      ann = currentState.selectedAnnounceMent.map((f) => URL.createObjectURL(f));
    }
    if (currentState.selectedGalleryImage?.length > 0) {
      gal = currentState.selectedGalleryImage.map((f) => URL.createObjectURL(f));
    }
    if (currentState.selectedServiceVideo?.length > 0) {
      vid = currentState.selectedServiceVideo.map((f) => URL.createObjectURL(f));
    }
    if (currentState.apiAnnounceMentImages?.length > 0) {
      ann = [...ann, ...currentState.apiAnnounceMentImages.map((fn) => `${API_URL}auth/image/${fn}`)];
    }
    if (currentState.apiGalleryImages?.length > 0) {
      gal = [...gal, ...currentState.apiGalleryImages.map((fn) => `${API_URL}auth/image/${fn}`)];
    }
    if (currentState.apiServiceVideo?.length > 0) {
      vid = [...vid, ...currentState.apiServiceVideo.map((fn) => `${API_URL}auth/video/${fn}`)];
    }

    let socialMedia = [];
    if (loginDetails.faceBook) socialMedia.push({ link: loginDetails.faceBook, icon: faceBook });
    if (loginDetails.instagram) socialMedia.push({ link: loginDetails.instagram, icon: instagram });
    if (loginDetails.linkedIn) socialMedia.push({ link: loginDetails.linkedIn, icon: linkedIn });
    if (loginDetails.youtube) socialMedia.push({ link: loginDetails.youtube, icon: youtube });
    if (loginDetails.personalWebsite)
      socialMedia.push({ link: loginDetails.personalWebsite, icon: personalWebsite });

    const businessLogo = Object.keys(currentState.businessLogo || {}).length
      ? URL.createObjectURL(currentState.businessLogo)
      : currentState.editBusinessLogo
        ? `${API_URL}auth/image/${currentState.editBusinessLogo}`
        : null;

    const refValues = getRefValues();
    const serviceName = refValues.serviceName || "Your Service Name";

    // This IS the shape of the saved "preference" record — the same shape
    // CalendarVcard receives as `response.data.data.eventData` and stores
    // directly as `state.eventDetails`. Theme components read fields off
    // this object (serviceName, primaryColor, themeId, etc.) by these
    // exact names, so it must match — not an ad-hoc shape.
    const eventDetails = {
      serviceName,
      description: currentState.description || "",
      businessLogo,
      serviceGalleryImage: gal.join(","),
      serviceAnnouncement: ann.join(","),
      serviceProviderVideo: vid.join(","),
      announcementContent: currentState.announceMentContent || "",
      meetingUrl: refValues.meetingLink || "",
      meetingInApplication: currentState.meetingInYuukke,
      showBookingCount: currentState.bookingCount,
      showProfileImage: currentState.profilePhoto,
      emailShow: currentState.emailShow,
      phoneNumberShow: currentState.phoneNumberShow,
      minBookingCount: refValues.minBookingCount,
      theme: currentState.theme,
      customTheme: currentState.needCustomTheme,
      themeId: currentState.themeId,
      fontFamily: currentState.fontFamily?.value,
      primaryColor: currentState.primaryColor,
      secondaryColor: currentState.secondaryColor,
      headingColor: currentState.headingColor,
      subHeadingColor: currentState.subHeadingColor,
      uiTheme: currentState.uiTheme.value,
      sliderTextOne: refValues.sliderTextOne || "",
      sliderTextTwo: refValues.sliderTextTwo || "",
      noOfClients: refValues.clients || "0",
      ratings: currentState.ratings?.value || "4.5",
      specialisations: currentState.specialisations?.join(",") || "",
      successMetrics: JSON.stringify(currentState.successMetrics || {}),
      countryName: currentState.country?.label,
      countryId: currentState.country?.id,
      demoSessionAvailable: currentState.demoSlotNeed,
      workSpaceType: 0,
    };

    // Mirrors CalendarVcard's full local `state` after updateData() —
    // both the themed components (`data={state}`) and DefaultThemeProfile
    // (`state={state}`) read fields directly off this object.
    const previewVcardState = {
      bookingPage: false,
      slots: [],
      availableSlot: [],
      activeIndexData: {},
      selectedSlot: null,
      slotActiveIndex: null,
      part: null,
      loader: false,
      eventDetails,
      userSlots: [],
      currentServiceSlots: [],
      userDetails: {
        userId: loginDetails.userId,
        userName: loginDetails.dName,
        email: loginDetails.email,
        phoneNumber: loginDetails.phoneNumber,
        personalWebsite: loginDetails.personalWebsite,
      },
      bookingCount: Number(refValues.minBookingCount) || 0,
      detailsPage: false,
      name: "",
      email: "",
      phoneNumber: "",
      description: "",
      bio: "",
      type: "",
      singleDate: new Date(),
      bookedSlot: [],
      paymentPage: false,
      paymentId: null,
      dayId: null,
      serviceList: userServiceList || [],
      serviceLists: userServiceList || [],
      serviceId: null,
      serviceAmount: 0,
      minutes: 0,
      appointmentValue: "",
      assessmentForm: false,
      assessmentQuestions: [],
      assessmentNeed: false,
      assessmentAnswer: [],
      socialMedia,
      serviceDetails: null,
      language: currentState.language?.length > 0
        ? currentState.language.map((lan) => ({ id: lan.value, language: lan.label })) : [],
      clarityService: null,
      chatBoxOpen: false,
      serviceProviderUserId: loginDetails.userId,
      serviceChatDetails: null,
      openServiceChatForm: false,
      themeCard: currentState.uiTheme.value,
      backThemCard: true,
      reviewList: [],
      recommendList: [],
      exitUser: null,
      userUpcomingMeting: [],
      customTheme: currentState.needCustomTheme,
      packageDays: "",
      timeSlots: "",
      bookingSuccess: false,
      bookingMode: "self",
      expertNote: "",
      category: currentState.subCategory?.map((c) => ({ categoryId: c.categoryId, primaryId: c.categoryId })) || [],
      hasMultiplePrimaryIds: (currentState.serviceType?.length ?? 0) > 1,
      resourceList: [],
      resourceListCount: 0,
      sliderText: getSliderText(eventDetails),
      isPreview: true,
    };

    previewTheme.current = previewVcardState.themeCard;
    previewDataRef.current = previewVcardState;
    setPreviewData(previewVcardState);

    if (isShow) {
      setPreviewVisible(true);
    }
  };

  const selectStyles = {
    ...dropFlowStyle,
    control: (base, s) => ({
      ...base,
      minHeight: 60,
      borderRadius: 12,
      border: s.isFocused ? "2px solid #a00030" : "1.5px solid #e5e7eb",
      boxShadow: s.isFocused ? "0 0 0 4px rgba(160,0,48,0.1)" : "none",
      fontSize: 17,
      "&:hover": { borderColor: "#b3b9c4" },
    }),
    placeholder: (base) => ({ ...base, fontSize: 16, color: "#9ca3af" }),
    valueContainer: (base) => ({ ...base, padding: "8px 16px" }),
    multiValue: (base) => ({ ...base, borderRadius: 8, background: "#fdf2f5" }),
    multiValueLabel: (base) => ({ ...base, color: "#a00030", fontWeight: 700, fontSize: 15 }),
  };

  /* ── Active theme resolution — mirrors CalendarVcard's activeThemeCard/ActiveThemeComponent ── */
  const previewThemeCard = previewData?.themeCard ?? state.uiTheme.value;
  const activeThemeCard = THEME_COMPONENTS[previewThemeCard] ? previewThemeCard : null;
  const ActiveThemeComponent = activeThemeCard !== null ? THEME_COMPONENTS[activeThemeCard] : null;

  const themeCardCommonProps = {
    data: previewData,
    selectService: () => {},
    userUpcomingMeting: () => {},
    onSendMsgClick: () => {},
    uploadDetails: (e) => e?.preventDefault?.(),
    updateState: () => {},
    confirmDetails: () => {},
    recaptcha,
    viewAvailableSlot: () => {},
    handleOpenReviews: () => {},
    onResourceClick: () => {},
  };

  /* ── RENDER ── */
  return (
    <>
      <BlockUi tag="div" message="Loading, please wait" style={{ minHeight: 134 }} className="wallLoadingPage" blocking={state.loader}>
        <div className="cps-shell">
          {/* Top bar */}
          <div className="cps-topbar">
            <div className="cps-topbar-left">
              <IoArrowBackCircleOutline onClick={() => onBack()} className="cps-back-icon" />
              <div>
                <span className="cps-eyebrow">{t("Profile Studio")}</span>
                <h1 className="cps-title">{t("Your")} <span>{t("provider profile")}</span></h1>
                <p className="cps-subtitle">
                  {t("Everything clients see, in one place")} — {completedSections} {t("of")} {navItems.length} {t("sections complete")}
                </p>
              </div>
            </div>
          </div>

          {/* Progress card */}
          <div className="cps-progress-card">
            <div className="cps-progress-head">
              <span className="cps-progress-label">{t("Profile completeness")}</span>
              <span className="cps-progress-pct">{completionPercent}%</span>
            </div>
            <div className="cps-progress-track">
              <div className="cps-progress-fill" style={{ width: `${completionPercent}%` }} />
            </div>
            <div className="cps-progress-pills">
              {navItems.map((item) => (
                <span
                  key={item.id}
                  className={`cps-pill ${item.done ? "done" : ""} ${activeSection === item.id ? "active" : ""}`}
                  onClick={() => setActiveSection(item.id)}
                >
                  {item.done ? "✓" : "•"} {t(item.label)}
                </span>
              ))}
            </div>
          </div>

          {/* Body: sidebar + panel */}
          <div className="cps-body">
            <nav className="cps-sidebar">
              {navItems.map((item) => (
                <button
                  type="button"
                  key={item.id}
                  className={`cps-nav-item ${activeSection === item.id ? "active" : ""}`}
                  onClick={() => setActiveSection(item.id)}
                >
                  <span className="cps-nav-icon">{item.icon}</span>
                  <span className="cps-nav-text">
                    <span className="cps-nav-label">{t(item.label)}</span>
                    <span className="cps-nav-sub">{t(item.sub)}</span>
                  </span>
                  {item.done && <span className="cps-nav-check">✓</span>}
                </button>
              ))}
            </nav>

            <main className="cps-panel">
              <form onSubmit={updatePreference}>
                {/* ══ 1 · You ══ */}
                {activeSection === 1 && (
                  <>
                    <PanelHeader num="1" icon="🏢" title={t("Who are you?")} subtitle={t("Tell clients what your business is and what you specialise in")} done={completionChecks.identity} />
                    <div className="cps-panel-body">
                      <div className="cps-grid-2">
                        <Field label={t("Business or service name")} hint={t("First thing clients see — make it clear and memorable")} required why={t("A clear name builds trust instantly")}>
                          <input className="cps-input" type="text" ref={serviceNameRef} defaultValue={state.serviceName} placeholder="e.g. Mentoring by Priya" onBlur={(e) => changeMade("serviceName", e.target.value)} />
                        </Field>

                        <Field label={t("Type of service")} hint={t("Pick the type that best fits — you can choose more than one")} required>
                          <Select classNamePrefix="react-select" options={categoryV2} value={state.serviceType} onChange={getSubcategory} isMulti placeholder="Select service type..." menuPortalTarget={dBody} styles={selectStyles} />
                        </Field>

                        <Field label={t("Area of expertise")} hint={t("Be specific — clients search by specialty")} required why={t("Specific categories get 3× more profile views")}>
                          <Select classNamePrefix="react-select" options={state.subCategoryList} value={state.subCategory} onChange={(e) => changeMade("subCategory", e)} isMulti placeholder="e.g. Career Counselling, Resume Writing..." menuPortalTarget={dBody} styles={selectStyles} />
                        </Field>

                        <Field label={t("Country")} hint={t("Clients can filter by location — make sure this is accurate")} required>
                          <Select classNamePrefix="react-select" options={state.countryList} value={state.country} onChange={(e) => changeMade("country", e)} placeholder="Select your country..." menuPortalTarget={dBody} styles={selectStyles} />
                        </Field>
                      </div>
                    </div>
                  </>
                )}

                {/* ══ 2 · About ══ */}
                {activeSection === 2 && (
                  <>
                    <PanelHeader num="2" icon="✍️" title={t("Describe what you do")} subtitle={t("Help clients understand exactly how you can help them")} done={completionChecks.about} />
                    <div className="cps-panel-body">
                      <div className="cps-tip">
                        {t("Profiles with detailed descriptions get")} <strong>{t("5× more bookings")}</strong>. {t("Spend 2 minutes here — it pays off.")}
                      </div>

                      <Field label={t("About your service")} hint={t("What do you offer? Who is it for? What problem do you solve? Aim for 3–5 sentences.")} required why={t("This is the most-read section on your profile")} className="mb-4">
                        <div className="cps-editor-wrap">
                          {/* KEY added to force remount when initial data loads, solving empty text box bug */}
                          <TextEditorQuestion key={`desc-${state.isUpdated ? "loaded" : "init"}`} editorStateValue={(e) => changeMade("description", e)} editorValue={state.editDescription} />
                        </div>
                      </Field>

                      <Field label={t("Announcement or special offer")} hint={t("Running a promotion? This shows as a banner on your profile. (optional)")}>
                        <div className="cps-editor-wrap">
                          {/* KEY added to force remount when initial data loads, solving empty text box bug */}
                          <TextEditorQuestion key={`ann-${state.isUpdated ? "loaded" : "init"}`} editorStateValue={(e) => changeMade("announceMentContent", e)} editorValue={state.editAnnounceMentContent} />
                        </div>
                      </Field>
                    </div>
                  </>
                )}

                {/* ══ 3 · Visibility ══ */}
                {activeSection === 3 && (
                  <>
                    <PanelHeader num="3" icon="📣" title={t("How clients see and reach you")} subtitle={t("Control what appears on your public profile — turn on as many as possible")} done={completionChecks.visibility} />
                    <div className="cps-panel-body">
                      <div className="cps-tip">
                        {t("We recommend turning on")} <strong>{t("profile photo, free demo, and booking count")}</strong> — {t("these three have the biggest impact on new client conversions.")}
                      </div>
                      <div className="cps-toggle-grid">
                        <ToggleCard label={t("Show my profile photo")} hint={t("Profiles with photos get 4× more clicks")} checked={state.profilePhoto} onChange={(v) => changeMade("profilePhoto", v)} />
                        <ToggleCard label={t("Show my email address")} hint={t("Lets clients reach you directly")} checked={state.emailShow} onChange={(v) => changeMade("emailShow", v)} />
                        <ToggleCard label={t("Show my phone number")} hint={t("Great for clients who prefer a quick call")} checked={state.phoneNumberShow} onChange={(v) => changeMade("phoneNumberShow", v)} />
                        <ToggleCard label={t("Offer a free demo session")} hint={t("Free demos convert 60% more new clients")} checked={state.demoSlotNeed} onChange={(v) => changeMade("demoSlotNeed", v)} />
                        <ToggleCard label={t("Display total booking count")} hint={t("Social proof — shows how popular you are")} checked={state.bookingCount} onChange={(v) => changeMade("bookingCount", v)} />
                      </div>
                    </div>
                  </>
                )}

                {/* ══ 4 · Booking ══ */}
                {activeSection === 4 && (
                  <>
                    <PanelHeader num="4" icon="📅" title={t("Booking preferences")} subtitle={t("Set how clients meet you and fine-tune your booking count display")} done={completionChecks.bookings} />
                    <div className="cps-panel-body">
                      <Field label={t("How do clients meet you?")} hint={t("Choose your preferred meeting method — you can change this anytime")} required>
                        <div className="cps-meeting-grid">
                          <div className={`cps-meeting-card ${state.meetingInYuukke ? "active" : ""}`} onClick={() => changeMade("meetingInYuukke", true)}>
                            <div className="cps-meeting-badge">✓</div>
                            <div className="cps-meeting-icon">🎯</div>
                            <div>
                              <div className="cps-meeting-title">{t("Use Yuukke's built-in meeting tool")}</div>
                              <div className="cps-meeting-desc">{t("Clients book directly inside Yuukke — no external link needed. Fully integrated with your calendar.")}</div>
                            </div>
                          </div>

                          <div className={`cps-meeting-card ${!state.meetingInYuukke ? "active" : ""}`} onClick={() => changeMade("meetingInYuukke", false)}>
                            <div className="cps-meeting-badge">✓</div>
                            <div className="cps-meeting-icon">🔗</div>
                            <div>
                              <div className="cps-meeting-title">{t("Use my own meeting link")}</div>
                              <div className="cps-meeting-desc">{t("Paste a Google Meet, Zoom, Calendly, or Teams link for clients to use.")}</div>
                            </div>
                          </div>
                        </div>
                      </Field>

                      <div className={`cps-ext-wrap ${!state.meetingInYuukke ? "open" : ""}`}>
                        <div className="cps-ext-inner">
                          <div className="cps-ext-label">
                            🔗 {t("Your external meeting link")} <span className="cps-req">*</span>
                          </div>
                          <div className="cps-platform-row">
                            {["Google Meet", "Zoom", "Calendly", "Teams"].map((name) => (
                              <span key={name} className="cps-tag-pill" onClick={() => {
                                const urls = { "Google Meet": "https://meet.google.com/", Zoom: "https://zoom.us/j/", Calendly: "https://calendly.com/", Teams: "https://teams.microsoft.com/" };
                                if (meetingLinkRef.current) meetingLinkRef.current.value = urls[name];
                              }}>
                                {name}
                              </span>
                            ))}
                          </div>
                          <input className="cps-input" style={{ background: "#fff" }} type="url" ref={meetingLinkRef} defaultValue={state.meetingLink} placeholder="https://meet.google.com/your-link" onBlur={(e) => changeMade("meetingLink", e.target.value)} />
                        </div>
                      </div>

                      <hr className="cps-divider" />

                      <div className="cps-grid-2" style={{ alignItems: "flex-start" }}>
                        <Field label={t("Show booking count after how many bookings?")} hint={t("Prevents showing '1 booking' which looks sparse. We recommend starting at 5.")} required>
                          <input className="cps-input" type="number" ref={minBookingCountRef} defaultValue={state.minBookingCount} placeholder="e.g. 5" min="1" style={{ maxWidth: 260 }} onBlur={(e) => { changeMade("minBookingCount", e.target.value); setBookingThreshold(e.target.value); }} />
                          <div className="cps-count-preview">
                            <div className={`cps-count-dot ${bookingThreshold > 0 ? "on" : ""}`} />
                            <span>{bookingThreshold > 0 ? `Booking count will appear after ${bookingThreshold} booking${Number(bookingThreshold) === 1 ? "" : "s"}.` : "Enter a number above to see a preview"}</span>
                          </div>
                        </Field>
                      </div>
                    </div>
                  </>
                )}

                {/* ══ 5 · Page style ══ */}
                {activeSection === 5 && (
                  <>
                    <PanelHeader num="5" icon="🎨" title={t("Page style and language")} subtitle={t("Customise how your profile looks and which languages you work in")} done={completionChecks.look} />
                    <div className="cps-panel-body">
                      <div className="cps-grid-2">
                        <Field label={t("Your timezone")} hint={t("Used to show your availability correctly to clients in other regions")} required>
                          <Select classNamePrefix="react-select" options={timeZone} value={state.timeZone} onChange={(e) => changeMade("timeZone", e)} placeholder="Select your timezone..." menuPortalTarget={dBody} styles={selectStyles} />
                        </Field>

                        <Field label={t("Languages you communicate in")} hint={t("Clients filter by language — add all you're comfortable with")} required why={t("Multi-language profiles reach 40% more clients")}>
                          <Select classNamePrefix="react-select" options={languagelist} value={state.language} onChange={(e) => changeMade("language", e)} isMulti placeholder="e.g. English, Tamil, Hindi..." menuPortalTarget={dBody} styles={selectStyles} />
                        </Field>

                        <Field label={t("Main headline")} hint={t("The first line clients read — make it compelling")} required why={t("A strong headline = more profile clicks")}>
                          <input className="cps-input" type="text" ref={sliderTextOneRef} defaultValue={state.sliderTextOne} placeholder="e.g. Helping founders build career-defining products" onBlur={(e) => changeMade("sliderTextOne", e.target.value)} />
                        </Field>

                        <Field label={t("Page font style")} hint={t("Pick a font that matches your brand personality")}>
                          <Select classNamePrefix="react-select" options={fontOptions} onChange={(option) => { document.documentElement.style.setProperty("--test-font", option.value); changeMade("fontFamily", option); }} value={state.fontFamily} placeholder="Choose a font..." menuPortalTarget={dBody} styles={selectStyles} />
                        </Field>

                        <Field label={t("Page layout theme")} hint={t("Select the visual layout for your profile")}>
                          <Select
                            classNamePrefix="react-select"
                            options={availableUiThemeOptions}
                            onChange={onUiThemeChange}
                            value={state.uiTheme}
                            placeholder="Choose layout..."
                            menuPortalTarget={dBody}
                            styles={selectStyles}
                          />
                        </Field>

                        {/* FIX: Changed logical condition so Supporting tagline and stats render for ALL themes except Minimal (value 0) */}
                        {state.uiTheme.value !== 0 && (
                          <Field label={t("Supporting tagline")} hint={t("A secondary line shown below your main headline")}>
                            <input className="cps-input" type="text" ref={sliderTextTwoRef} defaultValue={state.sliderTextTwo} placeholder="e.g. 10 years · 500+ clients · Results guaranteed" onBlur={(e) => changeMade("sliderTextTwo", e.target.value)} />
                          </Field>
                        )}
                      </div>

                      {state.uiTheme.value !== 0 && (
                        <div className="cps-inline-pair">
                          <Field label={t("How many clients have you served?")} hint={t("Shows on your profile as a trust signal — be honest")} required why={t("Visible client numbers increase booking confidence")} className="flex-1">
                            <input className="cps-input" type="number" ref={clientsRef} defaultValue={state.clients} placeholder="e.g. 250" onBlur={(e) => changeMade("clients", e.target.value)} />
                          </Field>
                          <Field label={t("Your self-rated expertise (out of 5)")} hint={t("Clients appreciate honesty more than a perfect score")} required className="flex-1">
                            <Select classNamePrefix="react-select" options={ratList} onChange={(option) => changeMade("ratings", option)} value={state.ratings} placeholder="Rate yourself..." menuPortalTarget={dBody} styles={selectStyles} />
                          </Field>
                        </div>
                      )}

                      <div className="cps-theme-block">
                        <div className={`cps-check-row ${state.needCustomTheme ? "on" : ""}`} onClick={toggleNeedCustomTheme}>
                          <CheckBox value={state.needCustomTheme} label={t("Use a custom colour theme for my page (instead of Yuukke default)")} onChange={toggleNeedCustomTheme} questionMark={false} />
                        </div>
                        {state.needCustomTheme && (
                          <div className="cps-conditional">
                            <span className="cps-conditional-title">{t("Choose your brand colours")}</span>
                            <ColorPickerV2 pageData={previewData} themeVal={previewTheme.current} data={state.theme} onChange={changeColor} primary={state.primaryColor} secondary={state.secondaryColor} heading={state.headingColor} subHeading={state.subHeadingColor} />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {/* ══ 6 · Media ══ */}
                {activeSection === 6 && (
                  <>
                    <PanelHeader num="6" icon="📸" title={t("Photos and videos")} subtitle={t("Profiles with photos get 3× more views")} done={completionChecks.media} />
                    <div className="cps-panel-body">
                      <div className="cps-tip">
                        {t("Add at least a")} <strong>{t("logo or profile photo")}</strong> {t("to complete this section. A short intro video can")} <strong>{t("double your booking rate")}</strong>.
                      </div>
                      <div className="cps-grid-2">
                        <div className="cps-field">
                          <label className="cps-label">{t("Business logo or profile photo")} <span className="cps-req">*</span></label>
                          <span className="cps-hint">{t("Square image works best · JPG, PNG or SVG")}</span>
                          <div className="cps-upload">
                            {state.editBusinessLogo || state.businessLogo ? (
                              <ImagePreview apiLogo={state.apiLogo} file={state.apiLogo ? state.editBusinessLogo : state.businessLogo} removeFiles={() => setState((p) => ({ ...p, editBusinessLogo: null, businessLogo: null, changeMade: true }))} />
                            ) : (
                              <StepperFileOption onUploadSuccess={(file) => setState((p) => ({ ...p, businessLogo: file[0], apiLogo: false, changeMade: true }))} acceptedType=".jpg,.jpeg,.png,.svg" />
                            )}
                          </div>
                        </div>

                        <div className="cps-field">
                          <label className="cps-label">{t("Gallery images")} <span className="cps-media-tag">{t("multiple allowed")}</span></label>
                          <span className="cps-hint">{t("Show your workspace, events, certificates or past work")}</span>
                          <div className="cps-upload">
                            <StepperFileOption onUploadSuccess={(file) => setState((p) => ({ ...p, changeMade: true, selectedGalleryImage: [...state.selectedGalleryImage, ...file] }))} acceptedType=".jpg,.jpeg,.png,.svg" />
                          </div>
                          {state.apiGalleryImages && (
                            <div className="cps-thumb-row">
                              {state.apiGalleryImages.map((item, i) => (
                                <ImagePreview key={i} apiLogo file={item} removeFiles={(idx) => removeApiGalleryImage(idx, "apiImage")} />
                              ))}
                              {state.selectedGalleryImage.map((item, i) => (
                                <ImagePreview key={i} apiLogo={false} file={item} removeFiles={(idx) => removeApiGalleryImage(idx, "selectedImage")} />
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="cps-field">
                          <label className="cps-label">{t("Announcement images")} <span className="cps-media-tag">{t("multiple allowed")}</span></label>
                          <span className="cps-hint">{t("Images shown alongside your announcement banner")}</span>
                          <div className="cps-upload">
                            <StepperFileOption onUploadSuccess={(file) => setState((p) => ({ ...p, changeMade: true, selectedAnnounceMent: [...state.selectedAnnounceMent, ...file] }))} acceptedType=".jpg,.jpeg,.png,.svg" />
                          </div>
                          <div className="cps-thumb-row">
                            {state.apiAnnounceMentImages?.map((item, i) => (
                              <ImagePreview key={i} apiLogo file={item} removeFiles={(idx) => removeAnnounceMentImage(idx, "apiImage")} />
                            ))}
                            {state.selectedAnnounceMent?.map((item, i) => (
                              <ImagePreview key={i} apiLogo={false} file={item} removeFiles={(idx) => removeAnnounceMentImage(idx, "selectedImage")} />
                            ))}
                          </div>
                        </div>

                        <div className="cps-field">
                          <label className="cps-label">{t("Intro or demo video")} <span className="cps-media-tag">mp4 / m4v · max 50 MB</span></label>
                          <span className="cps-hint">{t("A 60-second intro video can double your booking rate")}</span>
                          <div className="cps-upload">
                            <ChooseFileComponent onUploadSuccess={onUploadSuccess} acceptedType=".mp4,.m4v" />
                          </div>
                          <div className="cps-thumb-row">
                            {state.apiServiceVideo?.map((item, i) => (
                              <ImagePreview key={`${item}-${i}`} apiLogo file={item} fileType="video" index={i} removeFiles={(idx) => removeServiceVideo(idx, "apiVideo")} />
                            ))}
                            {state.selectedServiceVideo?.map((item, i) => (
                              <ImagePreview key={i} apiLogo={false} file={item} index={i} fileType="video" removeFiles={(idx) => removeServiceVideo(idx, "selectedVideo")} />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* ══ 7 · Highlights ══ */}
                {activeSection === 7 && hasSingleServiceType && (
                  <>
                    <PanelHeader num="7" icon="📊" title={t("Specialisations & success metrics")} subtitle={t("Shown on your profile as expertise tags and a stats grid — both optional")} done={highlightsDone} />
                    <div className="cps-panel-body">
                      <div className="cps-tip">
                        {t("These are optional, but profiles with specific specialisations and real numbers convert noticeably better than generic ones.")}
                      </div>

                      <Field label={t("Specialisations")} hint={t("Type a phrase and press Enter (or comma) to add it as a tag — e.g. 'Tailored business strategies', 'Expert advice sessions'")} className="mb-4">
                        <TagInput tags={state.specialisations} draft={specialisationDraft} onDraftChange={setSpecialisationDraft} onChange={updateSpecialisations} placeholder="e.g. Tailored business strategies" maxTags={20} />
                        {state.specialisations.length === 0 && (
                          <span className="cps-tag-empty-hint">{t("No specialisations added yet — this section stays hidden on your profile until you add at least one.")}</span>
                        )}
                      </Field>

                      <hr className="cps-divider" />

                      <Field label={t("Success metrics")} hint={t("Shown as a stat grid on your profile — enter exactly how you want each number displayed (e.g. '$84M+', '312k', '+284%'). Leave any blank to hide that card.")}>
                        <div className="cps-grid-4">
                          {successMetricFields.map((field) => (
                            <div key={field.key} className="cps-metric-input-card">
                              <span className="cps-metric-input-label">{field.label}</span>
                              <input className="cps-input-sm" type="text" value={state.successMetrics[field.key] ?? ""} placeholder={field.placeholder} onChange={(e) => updateSuccessMetric(field.key, e.target.value)} />
                            </div>
                          ))}
                        </div>
                      </Field>
                    </div>
                  </>
                )}

                {/* ── Footer ── */}
                <div className="cps-panel-footer">
                  <div className="cps-footer-note">
                    {completionPercent < 100 ? (
                      <span>
                        {100 - completionPercent}% {t("left — complete all sections to maximise visibility")}
                      </span>
                    ) : (
                      <span className="done" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        {t("Your profile is fully complete!")}
                      </span>
                    )}
                  </div>
                  <div className="cps-footer-btns">
                    <button
                      type="button"
                      className="unified-secondary-btn"
                      onClick={() => onPreviewClick(state, true)}
                    >
                      <FiEye size={16} strokeWidth={2.5} /> {t("Preview my profile")}
                    </button>
                    <button
                      type="submit"
                      className="unified-primary-btn"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      {t("Save my profile")}
                    </button>
                  </div>
                </div>
              </form>
            </main>
          </div>
        </div>

        {/* ── Dynamic Preview Modal ── */}
        <Modal open={isPreviewVisible}>
          <div className="cps-modal-content">
            <IconButton size="small" className="cps-modal-close" onClick={() => setPreviewVisible(false)}>
              <IoClose size={25} color="#E55050" />
            </IconButton>
            <div className="cps-modal-inner">
              {ActiveThemeComponent ? (
                React.createElement(ActiveThemeComponent, {
                  ...themeCardCommonProps,
                  ...(THEME_CARD_WITHOUT_PREVIEW_PROP.has(activeThemeCard) ? {} : { isPreview: true }),
                })
              ) : (
                <DefaultThemeProfile
                  state={previewData}
                  setState={setPreviewData}
                  isMobile={window.screen.width < 768}
                  isPreview={true}
                  primaryColor={() => previewData?.eventDetails?.primaryColor || ""}
                  secondaryColor={() => previewData?.eventDetails?.secondaryColor || ""}
                  toCamelCase={toCamelCase}
                  selectService={() => {}}
                  cancelMeeting={() => {}}
                  confirmDetails={() => {}}
                  uploadDetails={(e) => e?.preventDefault?.()}
                  updateState={() => {}}
                  viewAvailableSlot={() => {}}
                  recaptcha={recaptcha}
                  isHovered={previewIsHovered}
                  setIsHovered={setPreviewIsHovered}
                  setShowServiceDropdown={setPreviewShowServiceDropdown}
                  showServiceDropdown={previewShowServiceDropdown}
                  setScrollPosition={setPreviewScrollPosition}
                  setCurrentIndex={setPreviewCurrentIndex}
                  calYear={previewCalYear}
                  calMonth={previewCalMonth}
                  setCalYear={setPreviewCalYear}
                  setCalMonth={setPreviewCalMonth}
                  packageDays={[]}
                  timeSlots={[]}
                  serviceError={previewServiceError}
                  setServiceError={setPreviewServiceError}
                  handleBackFromBooking={() => {}}
                  handleResourceClick={() => {}}
                  updatePaymentStatus={() => {}}
                  API_URL={API_URL}
                  REACT_APP_SITE_KEY={REACT_APP_SITE_KEY}
                  optionsMenu={optionsMenu}
                />
              )}
            </div>
          </div>
        </Modal>
      </BlockUi>
    </>
  );
}

export default withTranslation()(withRouter(CalendarPlans));